module.exports = __webpack_public_path__ + "static/media/sqwad-hand.e3d2261a.png";